import styled from '@emotion/styled';

export const TranslationsWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 500;
`;

export const TranslationsModalBody = styled.div`
    background-color: white;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
`;

export const LoaderWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const modalCustomStyles = {
    width: '97vw',
    height: '97vh',
};
